export const EVENT_TYPES = {
	COMPONENT_ANIMATION_HEIGHT: 'componentAnimationHeight',
	COMPONENT_TOGGLE:           'componentToggle',
};

export const EVENT_TYPE_STATES = {
	START: 'start',
	END:   'end',
	ON:    'on',
	OFF:   'off',
};
